import { useMutation } from "@tanstack/react-query";

import { CreateStatsTableRequestDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useCreateStatsTable = () => {
  const { statsControllerApi } = useApi();

  return useMutation({
    mutationFn: (data: CreateStatsTableRequestDto) =>
      statsControllerApi.createStatsTable(data),
  });
};
